<template lang="pug">
  b-card.gl-loading-card(:class="{ 'no-border': options.border === 'none', 'page': options.location === 'page' }")
    div(layout="row" layout-align="center center")
      pulse-loader(:loading="true" :color="'#8EA2AC'" :size="'12px'")
      span.gl-loading-card__message {{ options.message }}
</template>

<script>
export default {

  // props
  props: {
    options: Object
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/colors';

  .gl-loading-card {
    &.no-border {
      border: none;
    }
    &.page {
      margin: 0 auto;
      max-width: 650px;
    }

    &__message {
      margin: 0 16px;
      color: $gl-grey;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-loading-card.vue